import { SCORE_VALUE } from '../../../../constants/sentimentScore.constant';

export const getScoreColor = (score: number) => {
  if (score >= SCORE_VALUE.EXCELLENT) return 'text-green-600';
  if (score >= SCORE_VALUE.GOOD) return 'text-yellow-600';
  if (score >= SCORE_VALUE.NEEDS_IMPROVEMENT) return 'text-orange-600';
  return 'text-red-600';
};
